// extracted by mini-css-extract-plugin
export default {"card":"Card_card__CtUL6","card-actions":"Card_card-actions__4kQIN"};